import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PresidentsGraph from '../PresidentsGraph';
import components from './components';
import variables from './variables';
import s from './Presidents.css';

const maxFactorFontSize = 48;
const positiveColor = '#0a0';
const negativeColor = '#a00';
const numVariables = variables.length;

class Presidents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      useComponents: true,
      xIndex: 0,
      yIndex: 1,
    };
  }

  axisOptions(axis) {
    if (this.state.useComponents) {
      return Array(...Array(numVariables)).map((_, i) => (
        <option
          value={i}
          key={axis + i}
        >
          comp {i + 1}
        </option>
      ));
    }
    return variables.map((variable, i) => (
      <option
        value={i}
        key={axis + i}
      >
        {variable}
      </option>
    ));
  }

  handleRankingsClick() {
    this.setState({
      useComponents: false,
      xIndex: 0,
      yIndex: 1,
    });
  }

  handleComponentsClick() {
    this.setState({
      useComponents: true,
      xIndex: 0,
      yIndex: 1,
    });
  }

  handleXIndexChange(evt) {
    this.setState({ xIndex: parseInt(evt.target.value, 10) });
  }

  handleYIndexChange(evt) {
    this.setState({ yIndex: parseInt(evt.target.value, 10) });
  }

  renderDescription() {
    return (
      <div>
        <p>
          Some historians find it fun to rank presidents, and they do this
          regularly in the&nbsp;
          <a href="https://www.siena.edu/centers-institutes/siena-research-institute/social-cultural-polls/us-presidents-study/">
            Sienna Research Institute Presidents Study
          </a>
          , ranking all past presidents on 20 different criteria. I noticed
          that the rankings are heavily redundant. Just look at "overall
          ability" versus "executive ability" - that's 96% correlation! To make
          a bit more
          sense of this 20-dimensional data (a ranking for each category for
          each president), I plotted each president's rankings in
          20-dimensional space, then rotated and recentered them so that the
          axes line up with the directions the data varies in.
        </p>
        <p>
          Click on a president to follow him, and compare different axes!
        </p>
      </div>
    );
  }

  renderForm() {
    return (
      <form className={s.form}>
        <div className={s.verticalInput}>
          <div>
            <input
              type="radio"
              name="basis"
              value="original rankings"
              onChange={() => this.handleRankingsClick()}
              checked={!this.state.useComponents}
            />
            Rankings
          </div>

          <div>
            <input
              type="radio"
              name="basis"
              value="principal components"
              onChange={() => this.handleComponentsClick()}
              checked={this.state.useComponents}
            />
            Principal Components
          </div>
        </div>

        <div className={s.verticalInput}>
          <div className={s.axis}>
            X axis
            <select
              value={this.state.xIndex}
              onChange={(evt) => this.handleXIndexChange(evt)}
            >
              {this.axisOptions('x')}
            </select>
          </div>

          <div className={s.axis}>
            Y axis
            <select
              value={this.state.yIndex}
              onChange={(evt) => this.handleYIndexChange(evt)}
            >
              {this.axisOptions('y')}
            </select>
          </div>
        </div>
      </form>
    );
  }

  renderGraph() {
    return (
      <PresidentsGraph
        useComponents={this.state.useComponents}
        xIndex={this.state.xIndex}
        yIndex={this.state.yIndex}
      />
    );
  }

  renderComponents() {
    if (this.state.useComponents) {
      return (
        <div>
          {this.renderComponentHeadline('x')}
          {this.renderComponentFactors(this.state.xIndex)}
          {this.renderComponentHeadline('y')}
          {this.renderComponentFactors(this.state.yIndex)}
        </div>
      );
    }
    return (
      <div className={s.componentHeadline}>
        Remember that low rankings are better!
      </div>
    );
  }

  renderComponentHeadline(axisName) {
    return (
      <div className={s.componentHeadline}>
        Factors the {axisName} axis
        (component {this.state[`${axisName}Index`] + 1})
        is&nbsp;
        <span style={{ color: positiveColor }}>
          positively
        </span>
        &nbsp;and&nbsp;
        <span style={{ color: negativeColor }}>
          negatively
        </span>
        &nbsp;affected by:
      </div>
    );
  }

  renderComponentFactors(axis) {
    const factors = Array(...Array(numVariables))
      .map((_, i) => i)
      .sort((i, j) => components[axis][i] > components[axis][j] ? 1 : -1)
      .map(
        (i, c) => this.renderComponentFactor(
          axis,
          variables[i],
          i,
          c !== variables.length - 1,
        ),
      );
    return (
      <div className={s.factors}>
        {factors}
      </div>
    );
  }

  renderComponentFactor(axis, variable, i, addComma) {
    const style = {
      fontSize: Math.abs(components[axis][i]) * maxFactorFontSize,
      color: components[axis][i] < 0 ? '#0a0' : '#a00',
    };
    const key = `factor-${i}`;
    const maybeComma = addComma ? ',' : '';

    return (
      <div className={s.factor} style={style} key={key}>
        {variable}{maybeComma}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderDescription()}
        {this.renderForm()}
        {this.renderGraph()}
        {this.renderComponents()}
      </div>
    );
  }
}

export default withStyles(s)(Presidents);



// WEBPACK FOOTER //
// src/components/Presidents/Presidents.js